import { render, staticRenderFns } from "./AvailableContentCount.vue?vue&type=template&id=5b474342&scoped=true&"
import script from "./AvailableContentCount.vue?vue&type=script&lang=ts&"
export * from "./AvailableContentCount.vue?vue&type=script&lang=ts&"
import style0 from "./AvailableContentCount.vue?vue&type=style&index=0&id=5b474342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b474342",
  null
  
)

export default component.exports